import i18n from '@/settings/i18n';
import { useProductPageContext } from './hooks/useProductPageContext';
import { getComesWithItems } from './comes-with';

const t = i18n.init('product');

/**
 * What the device ships with, above the seller line.
 *
 * Driven by the selected SKU's category, so it follows a variant change, and
 * rendered only when that category has items - a category with none shows no
 * heading and no empty state.
 */
const ComesWith = () => {
  const {
    selectedSkuDetails: { categoryName },
  } = useProductPageContext();

  const items = getComesWithItems(categoryName);

  if (items.length === 0) {
    return null;
  }

  return (
    <div className="mb-2 px-5 lg:px-0" id="comes-with">
      <h2 className="mb-2 text-sm font-bold">{t`Comes with:`}</h2>
      <div className="flex flex-wrap gap-2">
        {items.map(({ label, icon: Icon }) => (
          <div
            key={label}
            className="flex h-8 w-fit items-center gap-2 rounded-full bg-[#F8F8F8] px-3.5 text-xs font-medium"
          >
            <Icon className="h-3.5 w-3.5 shrink-0" />
            {t(label)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComesWith;
